import script from "./BaseToggle.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseToggle.vue?vue&type=script&setup=true&lang=js"

import "./BaseToggle.vue?vue&type=style&index=0&id=152e4344&lang=scss"

const __exports__ = script;

export default __exports__